/**
 *
 *  Constants used throughout the App
 *
 */

const HOME_URL = '/dashboard/students'
const HOME_LABEL = 'Dashboard'

const STORE_URL = '/tableview'
const STORE_LABEL = 'Tableview'

const STUDENTS_LABEL = 'Students'

const LOGO_IMAGE = '/logo.png'
const LOGO_LABEL = 'Winc Academy Logo'

const WINC_URL = 'https://wincadademy.nl'
const WINC_LABEL = 'Winc Academy'

const DEV_URL = 'https://leon.ist'
const DEV_LABEL = 'Leonist'

export {
    HOME_URL,
    HOME_LABEL,
    STORE_URL,
    STORE_LABEL,
    STUDENTS_LABEL,
    LOGO_IMAGE,
    LOGO_LABEL,
    WINC_URL,
    WINC_LABEL,
    DEV_URL,
    DEV_LABEL
}
